import { render } from "./IonIcon.vue?vue&type=template&id=7dab5e91&scoped=true"
import script from "./IonIcon.vue?vue&type=script&lang=js"
export * from "./IonIcon.vue?vue&type=script&lang=js"

import "./IonIcon.vue?vue&type=style&index=0&id=7dab5e91&lang=less&scoped=true"

import exportComponent from "D:\\project\\weshow-ent-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab5e91"]])

export default __exports__